import React from 'react';
import dayjs from 'dayjs';
import { Container, Box, Typography } from '@mui/material';
import { DynamicsChart } from '/@/app/components/DynamicsChart';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';


const NextExampleHeader = ({ children }) => {
    return (
        <Typography variant="h6" sx={{mt: 3}}>
            {children}
        </Typography>
    );
}


export const DynamicsCasesMain = () => {
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}

        >
            <Container maxWidth="sm">
                <Box sx={{
                    pr: {xs: 2, sm: 0},
                    pb: 10,  // keep bottom space for floating bottom panels
                }}>
                    <Typography variant="h2" gutterBottom>Динамика: Главные тест-кейсы</Typography>
                    <Typography variant="body1" gutterBottom>
                        По одному графику на кейс. Юнит-тесты.
                        Всю страницу отсматривать глазами.
                    </Typography>
                    <DynamicsCasesOverview />
                </Box>
            </Container>
        </HelpingDrawerLayout>
    );
}

const DynamicsCasesOverview = () => {
    return (
        <>
            <CASES.PartialReferences />
            <CASES.CurrentPanelSelected />
            <CASES.CurrentDateShown />
            <CASES.CurrentDateSoon />
            <CASES.CurrentDateOutOfRange />
            <CASES.CurrentPanelSelected />
            <CASES.FrailtyIndexIssue01 />
            <CASES.FrailtyIndexIssue02 />
            <CASES.FrailtyIndexIssue03 />
            <CASES.AdaptiveGreenFieldMargin01 />
            <CASES.AdaptiveGreenFieldMargin02 />
            <CASES.OptimalRangeBelowAxis />
            <CASES.NoData />
            <CASES.OnePoint />
            <CASES.TwoPoints />
            <CASES.MultiplePoints />
            <CASES.MultiplePointsScreenTooSmall />
            <CASES.CurrentPanelSelected />
            <CASES.FrequentLDLChecksZoomNeeded />
            <CASES.SameValues />
            <CASES.HigherValuesOnly />
            <CASES.LowerValuesOnly />
            <CASES.CRPBigSpreadNeedLogScale />
            <CASES.VerticalOverflowBloodPressureCase />
            <CASES.SparsePointsAlignment />
            <CASES.SparsePointsNoAlignment />
            <CASES.LastPointNewTest />
            <CASES.LastPointNewYearTest />
            <CASES.ValuesAtTheTop />
            <CASES.NoOptimalRangeData />
            <CASES.NullDataTest />
            <CASES.UndefinedDataTest />
            <CASES.ValuesFromFuture />

            <NextExampleHeader>TODO</NextExampleHeader>
            <Typography variant="body1" gutterBottom>
                Добавить следующие кейсы:
            </Typography>
            <Typography variant="body1" gutterBottom>
                - Объединённые графики (должна вычисляться общая дата начала и конца,
                графики должны быть выровнены (будущее, фича не утверждена).
            </Typography>
            <Typography variant="body1" gutterBottom>
                - очень далёкое расстояние от старого теста до текущей даты.
            </Typography>
            <Typography variant="body1" gutterBottom>
                - параметры fromDate, tillDate для DynamicsChart (пока не используются, обсудить с командой).
            </Typography>

        </>
    );
}


const CASES = {
    PartialReferences: () => {
        return (<>
            <NextExampleHeader>Не все точки имеют референсный диапазон</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2013-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2061,
                    "made_at": "2015-12-31T00:00:00Z",
                    "value": 4,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2016-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2061,
                    "made_at": "2017-12-31T00:00:00Z",
                    "value": 6,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2020-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2021-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2058,
                    "made_at": "2022-12-31T00:00:00Z",
                    "value": 3.0,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
            ]} />
        </>);
    },

    FrailtyIndexIssue01: () => {
        return (<>
            <NextExampleHeader>
                Frailty Index issue.
                Норма 0, но не выше.
                Если у человека 0, полоска должна быть окрашена целиком в зелёный.
                Договорились сделать фикс только для нуля - линия смещается вниз.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2110,
                    "made_at": "2022-01-01T07:37:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2116,
                    "made_at": "2022-02-01T09:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2133,
                    "made_at": "2023-03-01T11:06:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2114,
                    "made_at": "2023-04-01T08:48:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2131,
                    "made_at": "2023-05-01T08:45:00Z",
                    "value": 0.5,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2119,
                    "made_at": "2023-06-01T08:53:13.278Z",
                    "value": 10,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2119,
                    "made_at": "2023-07-01T08:53:13.278Z",
                    "value": 95,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                }
            ]} />
        </>);
    },
    FrailtyIndexIssue02: () => {
        return (<>
            <NextExampleHeader>
                Frailty Index issue.
                Норма 0, но не выше.
                Если у человека 0, полоска должна быть окрашена целиком в зелёный.
                Договорились сделать фикс только для нуля - линия смещается вниз.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2110,
                    "made_at": "2022-01-01T07:37:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2116,
                    "made_at": "2022-02-01T09:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2133,
                    "made_at": "2023-03-01T11:06:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2114,
                    "made_at": "2023-04-01T08:48:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2131,
                    "made_at": "2023-05-01T08:45:00Z",
                    "value": 0.5,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2119,
                    "made_at": "2023-06-01T08:53:13.278Z",
                    "value": 10,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2119,
                    "made_at": "2023-07-01T08:53:13.278Z",
                    "value": 11,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                }
            ]} />
        </>);
    },
    FrailtyIndexIssue03: () => {
        return (<>
            <NextExampleHeader>
                Frailty Index issue без выхода выше нормы.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2110,
                    "made_at": "2022-01-01T07:37:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2116,
                    "made_at": "2022-02-01T09:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2133,
                    "made_at": "2023-03-01T11:06:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2114,
                    "made_at": "2023-04-01T08:48:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2131,
                    "made_at": "2023-05-01T08:45:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                },
                {
                    "panel_id": 2119,
                    "made_at": "2023-06-01T08:53:13.278Z",
                    "value": 0,
                    "warning_bottom_edge": 0,
                    "warning_top_edge": 0
                }
            ]} />
        </>);
    },

    AdaptiveGreenFieldMargin01: () => {
        return (<>
            <NextExampleHeader>Поле оптимума должно выходить за край: но не слишком сильно. Диапазон несколько дней.</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2023-06-20T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    AdaptiveGreenFieldMargin02: () => {
        return (<>
            <NextExampleHeader>Поле оптимума должно выходить за край: но не слишком сильно. Диапазон несколько лет.</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2022-06-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2028-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },


    SameValues: () => {
        return (<>
            <NextExampleHeader>
                Одинаковые значения
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2057,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 3.63,
                    "warning_bottom_edge": 2.95,
                    "warning_top_edge": 5.2
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3.63,
                    "warning_bottom_edge": 2.95,
                    "warning_top_edge": 5.2
                },

            ]}/>
        </>);
    },

    ValuesFromFuture: () => {
        return (
            <>
                <NextExampleHeader>
                    Активировано отображение текущей даты, а данные выставлены в будущем. Ожидание: график не должен обрезаться.
                    (редкий кейс):
                </NextExampleHeader>
                <DynamicsChart data={[
                    {
                        "panel_id": 2057,
                        "made_at": "2022-06-30T00:00:00Z",
                        "value": 70,
                        "warning_bottom_edge": null,
                        "warning_top_edge": null
                    },
                    {
                        "panel_id": 2057,
                        "made_at": "2023-06-30T00:00:00Z",
                        "value": 79,
                        "warning_bottom_edge": null,
                        "warning_top_edge": null
                    },
                ]}/>
            </>
        );
    },

    HigherValuesOnly: () => {
        return (<>
            <NextExampleHeader>
                Кейс: Витамин B12, только высокие значения, нижняя граница существует.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2057,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 850,
                    "warning_bottom_edge": 200,
                    "warning_top_edge": 820
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 850,
                    "warning_bottom_edge": 200,
                    "warning_top_edge": 820
                },

            ]}/>
        </>);
    },
    LowerValuesOnly: () => {
        return (<>
            <NextExampleHeader>
                Кейс: Витамин B12, только низкие значения, нижняя граница существует.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2057,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 100,
                    "warning_bottom_edge": 200,
                    "warning_top_edge": 820
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 100,
                    "warning_bottom_edge": 200,
                    "warning_top_edge": 820
                },

            ]}/>
        </>);
    },
    NoData: () => {
        return (<>
            <NextExampleHeader>Нет данных</NextExampleHeader>
            <DynamicsChart data={[]} />
        </>);
    },
    OnePoint: () => {
        return (<>
            <NextExampleHeader>Одна точка</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]}/>
        </>);
    },

    TwoPoints: () => {
        return (<>
            <NextExampleHeader>Две точки</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2022-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    MultiplePoints: () => {
        return (<>
            <NextExampleHeader>Несколько точек</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2021-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2022-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2022-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    MultiplePointsScreenTooSmall: () => {
        return (<>
            <NextExampleHeader>Много точек, не вмещается в экран</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2010-04-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2017-04-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2017-10-01T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2018-01-30T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2018-11-01T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2019-04-10T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2020-01-01T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2020-08-10T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2020-11-10T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-10T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-03-31T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2022-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2022-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    CurrentPanelSelected: () => {
        return (<>
            <NextExampleHeader>Выбрана текущая панель - должна быть подсвечена</NextExampleHeader>
            <DynamicsChart
                currentPanel={{ id: 2060 }}
                data={[
                    {
                        "panel_id": 2061,
                        "made_at": "2021-12-31T00:00:00Z",
                        "value": 3.2,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.59
                    },
                    {
                        "panel_id": 2060,
                        "made_at": "2022-06-30T00:00:00Z",
                        "value": 0,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                    {
                        "panel_id": 2058,
                        "made_at": "2022-12-31T00:00:00Z",
                        "value": 1.66,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                    {
                        "panel_id": 2057,
                        "made_at": "2023-06-30T00:00:00Z",
                        "value": 3,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.59
                    }
                ]} />
        </>);
    },

    CurrentDateShown: () => {
        return (<>
            <NextExampleHeader>Отмечена текущая дата. Даты точек здесь динамические. Линия проходит через точку.</NextExampleHeader>
            <DynamicsChart
                showCurrentDate={true}
                data={[
                    {
                        "panel_id": 2061,
                        "made_at": dayjs().subtract(250, 'days').toISOString(),
                        "value": 3.2,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.59
                    },
                    {
                        "panel_id": 2060,
                        // is today
                        "made_at": dayjs().subtract(40, 'hours').toISOString(),
                        "value": 0,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                    {
                        "panel_id": 2060,
                        // after today:
                        "made_at": dayjs().add(100, 'days').toISOString(),
                        "value": 0,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                ]} />
        </>);
    },

    CurrentDateSoon: () => {
        return (<>
            <NextExampleHeader>Текущая дата за рамками диапазона, но скоро. Отображать.</NextExampleHeader>
            <DynamicsChart
                showCurrentDate={true}
                data={[
                    {
                        "panel_id": 2061,
                        "made_at": dayjs().subtract(250, 'days').toISOString(),
                        "value": 3.2,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.59
                    },
                    {
                        "panel_id": 2060,
                        // is today
                        "made_at": dayjs().subtract(40, 'hours').toISOString(),
                        "value": 0,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                ]} />
        </>);
    },

    CurrentDateOutOfRange: () => {
        return (<>
            <NextExampleHeader>
                Текущая дата за рамками диапазона, + несколько дней.
                Текущая дата должна быть скрыта, чтобы не было видно обрезанной подписи.
            </NextExampleHeader>
            <DynamicsChart
                showCurrentDate={true}
                data={[
                    {
                        "panel_id": 2061,
                        "made_at": dayjs().subtract(250, 'days').toISOString(),
                        "value": 3.2,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.59
                    },
                    {
                        "panel_id": 2060,
                        // is today
                        "made_at": dayjs().subtract(40, 'days').toISOString(),
                        "value": 0,
                        "warning_bottom_edge": 0.001,
                        "warning_top_edge": 2.9
                    },
                ]} />
        </>);
    },

    FrequentLDLChecksZoomNeeded: () => {
        return (<>
            <NextExampleHeader>Пользователь часто замеряет холестерин, нужен зумм</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2021-04-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-10-01T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-30T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-11-01T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-04-10T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-01T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-08-10T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-11-10T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-10T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-03-31T00:00:00Z",
                    "value": 1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2021-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },


    CRPBigSpreadNeedLogScale: () => {
        return (<>
            <NextExampleHeader>С-реактивный белок с большими разбросами, <b>логарифмическая шкала</b></NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2021-04-30T00:00:00Z",
                    "value": 0.1,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-10-01T00:00:00Z",
                    "value": 0.25,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-30T00:00:00Z",
                    "value": 0.8,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-11-01T00:00:00Z",
                    "value": 2.5,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-04-10T00:00:00Z",
                    "value": 20,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-01-01T00:00:00Z",
                    "value": 98,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-08-10T00:00:00Z",
                    "value": 200,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2021-10-10T00:00:00Z",
                    "value": 98,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                },
                {
                    "panel_id": 2061,
                    "made_at": "2022-01-10T00:00:00Z",
                    "value": 2.5,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 1.00
                }
            ]} />
        </>);
    },


    SparsePointsAlignment: () => {
        return (<>
            <NextExampleHeader>Редкие точки, общее выравнивание</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2015-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2018-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2020-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    SparsePointsNoAlignment: () => {
        return (<>
            <NextExampleHeader>Редкие точки, без общего выравнивания</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2061,
                    "made_at": "2015-12-31T00:00:00Z",
                    "value": 3.2,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                },
                {
                    "panel_id": 2060,
                    "made_at": "2018-06-30T00:00:00Z",
                    "value": 0,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2058,
                    "made_at": "2020-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },


    LastPointNewTest: () => {
        return (<>
            <NextExampleHeader>Крайняя справа точка: новый тест сдан</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2023-12-31T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    LastPointNewYearTest: () => {
        return (<>
            <NextExampleHeader>Крайняя справа точка: новый тест в новом году</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2023-01-11T00:00:00Z",
                    "value": 1.66,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.9
                },
                {
                    "panel_id": 2057,
                    "made_at": "2022-06-30T00:00:00Z",
                    "value": 3,
                    "warning_bottom_edge": 0.001,
                    "warning_top_edge": 2.59
                }
            ]} />
        </>);
    },

    VerticalOverflowBloodPressureCase: () => {
        return (<>
            <NextExampleHeader>Кейс с давлением 160, должна активироваться логарифмическая шкала, под высоту</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2022-01-01T01:00:00Z",
                    "value": 117,
                    "warning_bottom_edge": 110,
                    "warning_top_edge": 129
                },
                {
                    "panel_id": 2058,
                    "made_at": "2022-07-01T01:00:00Z",
                    "value": 117,
                    "warning_bottom_edge": 110,
                    "warning_top_edge": 129
                },
                {
                    "panel_id": 2058,
                    "made_at": "2023-03-01T01:00:00Z",
                    "value": 160,
                    "warning_bottom_edge": 110,
                    "warning_top_edge": 129
                },
                {
                    "panel_id": 2058,
                    "made_at": "2024-07-01T01:00:00Z",
                    "value": 114,
                    "warning_bottom_edge": 110,
                    "warning_top_edge": 129
                },
            ]} />
        </>);
    },

    ValuesAtTheTop: () => {
        return (<>
            <NextExampleHeader>
                Кейс: ОДИНАКОВЫЕ значения, НЕТ ДИАПАЗОНА, был баг: кружочки выходили за границу верха.
            </NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2057,
                    "made_at": "2021-06-30T00:00:00Z",
                    "value": 850,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2057,
                    "made_at": "2022-06-30T00:00:00Z",
                    "value": 850,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2057,
                    "made_at": "2023-06-30T00:00:00Z",
                    "value": 850,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
            ]}/>
        </>);
    },

    NoOptimalRangeData: () => {
        return (<>
            <NextExampleHeader>Когда нет данных о границах нормы, РАЗНЫЕ значения.</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2058,
                    "made_at": "2023-01-11T00:00:00Z",
                    "value": 170,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                },
                {
                    "panel_id": 2057,
                    "made_at": "2022-06-30T00:00:00Z",
                    "value": 171,
                    "warning_bottom_edge": null,
                    "warning_top_edge": null
                }
            ]} />
        </>);
    },


    NullDataTest: () => {
        return (<>
            <NextExampleHeader>null вместо данных</NextExampleHeader>
            <DynamicsChart data={undefined} />
        </>);
    },

    UndefinedDataTest: () => {
        return (<>
            <NextExampleHeader>undefined вместо данных</NextExampleHeader>
            <DynamicsChart data={null} />
        </>);
    },

    OptimalRangeBelowAxis: () => {
        return (<>
            <NextExampleHeader>Кейс с багом выхода оптимального значения ниже границы.</NextExampleHeader>
            <DynamicsChart data={[
                {
                    "panel_id": 2110,
                    "made_at": "2022-01-03T07:36:00Z",
                    "value": 4.4,
                    "warning_bottom_edge": 3.5,
                    "warning_top_edge": 5.49
                },
                {
                    "panel_id": 2116,
                    "made_at": "2022-01-26T08:59:00Z",
                    "value": 4.6,
                    "warning_bottom_edge": 3.5,
                    "warning_top_edge": 5.49
                },
                {
                    "panel_id": 2112,
                    "made_at": "2023-10-02T11:51:00Z",
                    "value": 4.4,
                    "warning_bottom_edge": 3.5,
                    "warning_top_edge": 5.49
                },
                {
                    "panel_id": 2114,
                    "made_at": "2024-01-10T08:47:00Z",
                    "value": 4.2,
                    "warning_bottom_edge": 3.5,
                    "warning_top_edge": 5.49
                }
            ]} />
        </>);
    }
}
